import { useState } from 'react';
import Styles from './IMSLogViewerControls.module.scss';

const FilterControls = props => {
	const [logIDField, setlogIDField] = useState({
		active: false,
		value: '',
	});
	const [typeField, setTypeField] = useState({
		active: false,
		value: 'Error',
	});
	const [sourceField, setSourceField] = useState({
		active: false,
		value: '',
	});
	const [hourField, setHourField] = useState({
		active: true,
		value: '1',
	});

	const handleLogIDChange = e => {
		setlogIDField({
			...logIDField,
			value: e.target.value,
		});
	};

	const handleTypeChange = e => {
		setTypeField({
			...typeField,
			value: e.target.value,
		});
	};
	const handleSourceChange = e => {
		setSourceField({
			...sourceField,
			value: e.target.value,
		});
	};
	const handleHourChange = e => {
		setHourField({
			...hourField,
			value: e.target.value,
		});
	};

	const formatArgString = () => {
		let argString = `F_Create_Date~${hourField.value}`;
		//if field is active, add the field and value to the string, F_Create_Date field included by default, only removed when searching based on logID

		if (typeField.active) {
			argString = argString + `,F_Type~${typeField.value}`;
		}
		if (sourceField.active) {
			argString = argString + `,F_Source~${sourceField.value}`;
		}
		//If LogID is active parameter, search only based on logID
		if (logIDField.active) {
			argString = `F_LogEntryID~${logIDField.value}`;
		}
		return argString;
	};

	const handleSearch = () => {
		let args = formatArgString();
		props.handleSearch(args);
	};

	return (
		<div className={Styles.controls_wrapper}>
			<div className={Styles.controls_container}>
				<div className={Styles.input_container}>
					<div className={Styles.label_container}>
						ID:
						<input
							className={Styles.radioButton}
							type='radio'
							name='LogID'
							checked={logIDField.active}
							onClick={() =>
								setlogIDField({
									...logIDField,
									active: !logIDField.active,
								})
							}
							onChange={() => {
								/**do nothing */
							}}
						/>
					</div>
					<input
						type='text'
						placeholder='Log ID'
						name='LogID'
						disabled={!logIDField.active}
						onChange={e => handleLogIDChange(e)}
					/>
				</div>
				<div className={Styles.input_container}>
					<div className={Styles.label_container}>
						Type:
						<input
							className={Styles.radioButton}
							type='radio'
							name='Type'
							checked={typeField.active}
							onClick={() =>
								setTypeField({
									...typeField,
									active: !typeField.active,
								})
							}
							onChange={() => {
								/**do nothing */
							}}
						/>
					</div>
					<select
						onChange={e => handleTypeChange(e)}
						disabled={!typeField.active || logIDField.active}
					>
						<option value='Error'>Error</option>
						<option value='Warning'>Warning</option>
						<option value='Information'>Information</option>
					</select>
				</div>
				<div className={Styles.input_container}>
					<div className={Styles.label_container}>
						Source:
						<input
							className={Styles.radioButton}
							type='radio'
							name='Source'
							checked={sourceField.active}
							onClick={() =>
								setSourceField({
									...sourceField,
									active: !sourceField.active,
								})
							}
							onChange={() => {
								/**do nothing */
							}}
						/>
					</div>
					<select
						onChange={e => handleSourceChange(e)}
						disabled={!sourceField.active || logIDField.active}
					>
						{props.sourceOptions
							? props.sourceOptions.map((option, index) => {
									return (
										<option
											value={option.value}
											key={index}
										>
											{option.label}
										</option>
									);
							  })
							: null}
					</select>
				</div>
				<div className={Styles.input_container}>
					<div className={Styles.label_container}>In The Past:</div>
					<select
						onChange={e => handleHourChange(e)}
						disabled={!hourField.active || logIDField.active}
					>
						<option value={1}>1 hour</option>
						<option value={6}>6 hours</option>
						<option value={12}>12 hours</option>
						<option value={24}>1 day</option>
						<option value={48}>2 days</option>
						<option value={168}>1 week</option>
					</select>
				</div>
				<div className={Styles.searchButton} onClick={handleSearch}>
					Search
				</div>
			</div>
		</div>
	);
};

export default FilterControls;
